import React from 'react';
export const Input = ({
  label,
  name,
  value,
  onChange,
  error,
  errorMessage
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: `expert-form__input-wrapper ${error && 'expert-form__input-wrapper--error'}`
  }, /*#__PURE__*/React.createElement("input", {
    className: "expert-form__input",
    name: name,
    value: value,
    onChange: onChange
  }), error && /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-error"
  }, errorMessage)));
};